import React from 'react'
import { Typography } from 'antd'
import { formatCurrency } from '../../utils/currency'
import { TaxLabel } from '../Footer/TaxLabel'
import { useCompanyStore } from '../../store/company/companyStore'

const { Text } = Typography

interface Props {
  subtotal: number
  tax: number
  total: number
}

export const OrderTotals: React.FC<Props> = ({ subtotal, tax, total }) => {
  const taxRate = useCompanyStore((state) => state.company.settings.taxRate)
  return (
    <div className="flex justify-end">
      <div className="w-[300px]">
        <div className="flex justify-between py-1">
          <Text>Subtotal:</Text>
          <Text>{formatCurrency(subtotal)}</Text>
        </div>

        <div className="flex justify-between py-1">
          <TaxLabel rate={taxRate} />
          <Text>{formatCurrency(tax)}</Text>
        </div>

        <div className="flex justify-between py-1 border-t font-bold">
          <Text>Total:</Text>
          <Text>{formatCurrency(total)}</Text>
        </div>
      </div>
    </div>
  )
}
